import React from 'react';
import './ModalTest.css';
import MD1 from '../../Assets/m1.png';
import MD2 from '../../Assets/m2.png';
import MD3 from '../../Assets/m3.png';
import MD4 from '../../Assets/m4.png';
import MD5 from '../../Assets/m5.png';
import MD6 from '../../Assets/m6.png';
import MD7 from '../../Assets/m7.png';
import MD8 from '../../Assets/m8.png';


function ModalTest() {
  return (
    <div className='Modal_Test'>
      <div className='Modal_Test_Head'>
        <h1>MODAL TEST CENTER</h1>
        <hr />
      </div>
      <div className='Modal2'>
      <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD1} alt="" />
        </div>
        <h5>1000</h5>
        <div className='Modal_Test_span'> 
        <span>CANIDATES</span>
        </div>
      </div>
      <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD2} alt="" />
        </div>
        <h5>1</h5>
        <div className='Modal_Test_span'> 
        <span>DISTRICT MANAGER</span>
        </div>
      </div>
      <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD3} alt="" />
        </div>
        <h5>1</h5>
        <div className='Modal_Test_span'> 
        <span>TEST CENTER SUPERVISER</span>
        </div>
      </div>
      <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD4} alt="" />
        </div>
        <h5>1</h5>
        <div className='Modal_Test_span'> 
        <span>CHEIF SUPERVISER</span>
        </div>
      </div> <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD5} alt="" />
        </div>
        <h5>10</h5>
        <div className='Modal_Test_span'> 
        <span>SUPERVISERS</span>
        </div>
      </div>
      <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD6} alt="" />
        </div>
        <h5>40</h5>
        <div className='Modal_Test_span'> 
        <span>INVAGILATORS</span>
        </div>
      </div>
      <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD7} alt="" />
        </div>
        <h5>5</h5>
        <div className='Modal_Test_span'> 
        <span>MONITORS</span>
        </div>
      </div>
      <div className='Modal_Test_main'>
        <div className='Modal_Test_img'>
        <img src={MD8} alt="" />
        </div>
        <h5>3</h5>
        <div className='Modal_Test_span'> 
        <span>ANNOUCEMENT DESK</span>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ModalTest
